 
import {useState} from "react";
import {BorderAll24Regular} from "@fluentui/react-icons";
import {Example} from "./Example";

import styles from "./Example.module.css";

const DEFAULT_EXAMPLES: string[] = [
    "Show me transactions with an amount greater than $100 last month.",
    "Show me the top ten employees with the highest discounts in the past 30 days.",
    "Create a file of transactions with Manager Discounts more than $20 this year.",
    "Can you show me a trend chart of all discount categories last month?"
];

const ADDITIONAL_EXAMPLES: string[] = [
    "Show me a trend chart for Voided $, Canceled $, and Refunds $ for last period.",
    "Show me sales by channel after 9 pm for the past 2 weeks.",
    "What is the check average across channels after 9 pm?",
    "Show me check average by employee WTD.",
    "List all transaction receipts with promo sales over $20 period to date.",
    "Has overall speed of service improved or declined in the last 30 days?",
    "List all transaction receipts with manager meal discount over $40 for last week.",
    "Show me the top ten employees with refunds over $20 last period.",
    "Provide me with a trend chart of transaction counts for last month.",
    "Aggregate sales by employee for Period 1.",
    "Show me a bubble chart of net sales, drive thru speed of service and labor % of sales for last period.",
    "Show me a trend chart with the net sales for the last hour open for the 60 days at this location.",
    "Using the following metrics for the last seven days, please compose a written summary of the results, including key performance highlights and opportunities for improvement. Metrics: Net Sales: Total Transactions: Average Transaction Value (ATV): Labor Cost %: Drive-Thru Service Operating Speed (SOS): Counter Service Operating Speed (SOS): Total Delivery Sales: from deliveries, please include an overview, highlights of strengths, and specific opportunities for improvement based on the provided data. Use the YOY metrics for the strengths and opportunities.",
    "Show me a trend chart of sales an hour after open and an hour before closing each day for the past 21 days."
];

const FULL_PROMPT_LIBRARY = DEFAULT_EXAMPLES.concat(ADDITIONAL_EXAMPLES);

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({onExampleClicked}: Props) => {
    const [showAll, setShowAll] = useState(false);
    const examplesToShow = showAll ? FULL_PROMPT_LIBRARY : DEFAULT_EXAMPLES;

    return (
        <>
            <div className={styles.examplesStack}>
                {examplesToShow.map((question, i) => (
                    <div key={i} className={styles.examplesStackItem}>
                        <Example
                            text={question}
                            value={question}
                            onClick={onExampleClicked}
                        />
                    </div>
                ))}
            </div>
            <div className={styles.toggleLinkContainer}>
                <button
                    className={styles.toggleLink}
                    onClick={() => setShowAll(!showAll)}
                >
                    <BorderAll24Regular className={styles.toggleIcon} />
                    {showAll ? "Show fewer prompts" : "Explore more prompts"}
                </button>
            </div>
        </>
    );
};
